import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from '../auth/auth.component';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@doddly/core';
import { InputTextModule } from 'primeng/inputtext';
import { CalloutComponent, IconComponent, LogoComponent } from '@doddly/shared';

@Component({
  selector: 'ly-sign-in',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AuthComponent,
    InputTextModule,
    IconComponent,
    CalloutComponent,
    LogoComponent,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent {
  isProcessing = false;
  invalidCredentials = false;
  signInForm = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.email, Validators.required],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  submit() {
    this.isProcessing = true;
    this.invalidCredentials = false;
    const email = this.signInForm.controls.email.value;
    const password = this.signInForm.controls.password.value;

    this.auth
      .signInWithEmailAndPassword(email, password)
      .catch(() => {
        this.invalidCredentials = true;
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  signInWithGoogle(): void {
    this.auth.signInWithGoogle().then(() => {
      this.router.navigate(['/']);
    });
  }
}
